import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class Contact extends DynamicFieldsSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      notes: '',
      priority: 9,
      allowedAccess: false,
      receivesSms: false,
      billPayer: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
